import { render } from "./AppDownloadView.vue?vue&type=template&id=ec434816&scoped=true"
import script from "./AppDownloadView.vue?vue&type=script&lang=js"
export * from "./AppDownloadView.vue?vue&type=script&lang=js"

import "./AppDownloadView.vue?vue&type=style&index=0&id=ec434816&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec434816"]])

export default __exports__